import AppPaths from '../../AppPaths';

/** Boolean growthbook feature; its experiment rule sends the `true` arm from the listing to the narrowed shop. */
export const PDP_SPLIT_FLAG = 'ecom-pdp-split';

const DEVICES = ['mini', 's3', 'ultra'];

/** The trackers named by `pdp=` (comma or hyphen separated), unknown keys dropped. Empty when the param is absent. */
export function parsePdpParam(search: string) {
  const raw = new URLSearchParams(search).get('pdp') ?? '';
  return raw
    .toLowerCase()
    .split(/[,-]/)
    .map((key) => key.trim())
    .filter((key, i, all) => DEVICES.includes(key) && all.indexOf(key) === i);
}

/**
 * The pdp arm's location: the shop narrowed to the named trackers with the first one open. The ad's
 * other params (utm, click ids, coupons, `type=cat`) ride along byte for byte; only `pdp=` is dropped.
 */
export function resolvePdpDestination(devices: string[], search: string) {
  const rest = search
    .replace(/^\?/, '')
    .split('&')
    .filter((pair) => pair && !pair.startsWith('pdp='));
  const own = [`products=${devices.join(',')}`, `selected=${devices[0]}`];
  return { pathname: AppPaths.Shop, search: `?${[...own, ...rest].join('&')}` };
}
